/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal, Label, Checkbox } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import api from '../../api';
//import userPic from '../../images/components/profile/profile_icon_1.png';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';
import WithRouter from '../Extensions/WithRouter';

class ApplyingPolicyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMAC: props.isOpenMAC,
      isOpen: false,
      itemsChecked: false,
      searchKeyword: '',
      errSearch: false,
      isFocus: false,
      searchResults: [],
      selectedFilter: '',
      checkValues: [],
    };
    this.onChangePolicyFilter = this.onChangePolicyFilter.bind(this);
    this.handleSearchPolicyChange = this.handleSearchPolicyChange.bind(this);
    this.handleSearchPolicy = this.handleSearchPolicy.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handlePolicyCheckAll = this.handlePolicyCheckAll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMAC } = this.props;

    if (prevProps.isOpenMAC !== isOpenMAC) {
      this.setState({
        isOpenMAC,
        checkValues: [],
        itemsChecked: false,
        searchResults: [],
        selectedFilter: '',
        errSearch: false,
        isFocus: false,
        searchKeyword: '',
      }, () => {
        if (isOpenMAC) {
          this.searchPolicy();
        }
      });
    }
  }

  handlePolicyCheckAll() {
    const { itemsChecked, searchResults } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValues: [],
      });
    } else {
      const num = searchResults.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(searchResults[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValues: unique,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValues } = this.state;
    let newState;

    if (checkValues.indexOf(value) > -1) {
      newState = checkValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValues, value];
    }
    this.setState({
      checkValues: newState,
    });
  }

  handleSearchPolicy(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          searchResults: [],
        },
        () => {
          this.searchPolicy();
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handleSearchPolicyChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  onSubmit() {
    const { checkValues, searchResults } = this.state;

    if (checkValues.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    const selectedArr = searchResults.filter((item) => {
      return checkValues.indexOf(item.id) > -1;
    });

    this.setState({
      isOpenMAC: false,
    });
    this.props.closeModal();
    this.props.completeCallback(selectedArr);
  }

  onChangePolicyFilter = (e) => {
    const { translate } = this.props;
    let newValue;
    switch (true) {
    case e.target.text.indexOf(translate('project.menu.component')) > -1:
      newValue = 'component';
      break;
    case e.target.text.indexOf(translate('project.menu.security')) > -1:
      newValue = 'security';
      break;
    case e.target.text.indexOf(translate('project.menu.license')) > -1:
      newValue = 'license';
      break;
    case e.target.text.indexOf(translate('project.menu.litigator')) > -1:
      newValue = 'litigator';
      break;
    default:
      newValue = '';
      break;
    }
    this.setState(
      {
        selectedFilter: newValue,
        searchResults: [],
      },
      () => {
        this.searchPolicy();
      }
    );
  };

  closeModal() {
    this.setState({
      isOpenMAC: false,
    });
    this.props.closeModal();
  }

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        searchResults: [],
      },
      () => {
        this.searchPolicy();
      }
    );
  }

  searchPolicy() {
    const { searchKeyword, selectedFilter } = this.state;
    const { excludeIds } = this.props;
    api
      .searchPolicy({
        search: searchKeyword,
        filter: selectedFilter,
        exclude_ids: excludeIds,
      })
      .then((response) => {
        if (response.count === 0) return;

        this.setState({
          searchResults: response.response,
        });
      });
  }

  render() {
    const {
      selectedFilter, searchKeyword, errSearch, isFocus, searchResults, itemsChecked, checkValues
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal open={this.state.isOpenMAC} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.applying_policy')}
                  {/**<em>Project Name</em>*/}
                </h2>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_tab">
                <a
                  className={selectedFilter === '' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangePolicyFilter}
                  onKeyUp={this.onChangePolicyFilter}
                >
                  {translate('settings.list.all')}
                </a>
                <a
                  className={selectedFilter === 'component' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangePolicyFilter}
                  onKeyUp={this.onChangePolicyFilter}
                >
                  {translate('project.menu.component')}
                </a>
                <a
                  className={selectedFilter === 'security' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangePolicyFilter}
                  onKeyUp={this.onChangePolicyFilter}
                >
                  {translate('project.menu.security')}
                </a>
                <a
                  className={selectedFilter === 'license' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangePolicyFilter}
                  onKeyUp={this.onChangePolicyFilter}
                >
                  {translate('project.menu.license')}
                </a>
                <a
                  className={selectedFilter === 'litigator' ? 'active' : null}
                  style={{ cursor: 'pointer' }}
                  onClick={this.onChangePolicyFilter}
                  onKeyUp={this.onChangePolicyFilter}
                >
                  {translate('project.menu.litigator')}
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={translate('modal.title.policy_name')}
                        onChange={this.handleSearchPolicyChange}
                        onKeyPress={this.handleSearchPolicy}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                      />
                      <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                      {isFocus && <Label pointing>{translate('modal.title.policy_name')}</Label>}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3" style={{ height: '322px' }}>
                      <Scrollbars>
                        <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '170px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th>
                                <Checkbox
                                  checked={itemsChecked}
                                  onChange={this.handlePolicyCheckAll}
                                />
                              </th>
                              <th>{translate('modal.title.policy_name')}</th>
                              <th>{translate('settings.list.category')}</th>
                              <th>{translate('settings.list.condition')}</th>
                            </tr>
                            {
                              searchResults.length !== 0 ? (
                                searchResults.map((result) => {
                                  return (
                                    <tr key={uuidv4()}>
                                      <td>
                                        <Checkbox
                                          value={result.id}
                                          checked={checkValues.indexOf(result.id) > -1}
                                          onChange={this.handleCheckChange}
                                        />
                                      </td>
                                      <td className="strong">{result.name}</td>
                                      <td className="strong">{result.category}</td>
                                      <td className="strong">{result.condition}</td>
                                    </tr>
                                  );
                                })
                              ) : null
                            }
                          </tbody>
                        </table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.onSubmit}
                    onKeyUp={this.onSubmit}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('settings.message.select_one_policy')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(ApplyingPolicyModal);
